import { render } from "./DataTableComponent2.vue?vue&type=template&id=216d0461"
import script from "./DataTableComponent2.vue?vue&type=script&lang=js"
export * from "./DataTableComponent2.vue?vue&type=script&lang=js"

import "./DataTableComponent2.vue?vue&type=style&index=0&id=216d0461&lang=css"
script.render = render

export default script